import { Outlet, useNavigate, useParams, NavLink } from "react-router-dom";
import EventSidebar from "../components/EventSidebar";
import Sidebar from "../components/Sidebar";
import EventMenu from "../menus/EventMenu";
import styles from "./Event.module.css";
import TimePicker from "../components/TimePicker";
import BanquetRoomPicker from "../components/BanquetRoomPicker";
import ServiceType from "../components/ServiceType";
import Button from "../components/Button";
import { useEffect, useRef, useState } from "react";
import Spinner from "../components/Spinner";
import ServerList from "../components/ServerList";
import { validateForm } from "../helpers/helperFunctions";
import AddOtherItemModal from "../modals/AddOtherItemModal";
import AddEmployeeModal from "../modals/AddEmployeeModal";
import AddMenuItemModal from "../modals/AddMenuItemModal";
import React from "react";
import { flashAlert, popup, popupClose } from "../global_js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import AddMenuNotesModal from "../modals/AddMenuNotesModal";
import ToggleSwitch from "../components/ToggleSwitch";
import Forbidden from "./Forbidden";
import AddOtherFoodModal from "../modals/AddOtherFoodModal";
import AddCommunicationModal from "../modals/AddCommunicationModal";
import CustomerSelectModal from "../modals/CustomerSelectModal";

function Event() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useRef(null);

  const [eventData, setEventData] = useState({});
  const [serverData, setServerData] = useState([]);
  const [banDetail, setBanDetail] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [communication, setCommunication] = useState([]);

  const userData = JSON.parse(localStorage.getItem("userLogin"));

  const detailRef = useRef(null);

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const makeInvalid = (e) => {
    e.target.classList.add("invalid");
  };

  const [tempInputValue, setTempInputValue] = useState(0.0);
  const [isEditMode, setIsEditMode] = useState(false);

  const categoryNames = {
    APP: "Appetizer",
    ENT: "Entree",
    DES: "Dessert",
    BEV: "Beverage (Bar)",
    "BEV-NA": "Beverage (NA)",
    OFI: "Other Food",
    ONF: "Other Non Food",
    FOOD: "Other Food",
  };

  useEffect(() => {
    setIsLoading(true);

    try {
      getEvent(id);
    } catch (error) {
      flashAlert(error, "error");
    }
  }, []);

  async function getEvent(id) {
    const res = await fetch("/api/event/" + id);
    if (res.ok) {
      const data = await res.json();

      await setEventData(data);
      await getCategories();
      await getComms();

      await getServers();
      //await getDetail();
      setIsLoading(false);
    } else {
      setIsLoading(false);
      return <Forbidden />;
    }
  }

  async function getServers() {
    const serv = await fetch("/api/servers/" + id);
    const servData = await serv.json();
    setServerData(servData);
  }

  async function getDetail() {
    const ban = await fetch("/api/detail/" + id);
    const banData = await ban.json();
    setBanDetail(banData);
  }

  async function getCategories() {
    const cat = await fetch("/api/categories/");
    const catData = await cat.json();
    setCategories(catData);
  }

  async function getComms() {
    const comms = await fetch("/api/event/comm/" + id);
    const commData = await comms.json();
    setCommunication(commData);
  }

  async function removeEmployee(emp) {
    await fetch("/api/servers", {
      method: "delete",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        id: emp.empId,
        banID: eventData.idBanquetHeader,
        user: userData.userId,
      }),
    });
    getServers();
  }

  async function removeOtherItem(itemID) {
    await fetch("/api/detail/addother/", {
      method: "delete",
      body: new URLSearchParams({
        itemId: itemID,
        id: eventData.idBanquetHeader,
        gratPercent: Number(eventData.percentGrat),
        userId: userData.userId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setEventData({
          ...eventData,
          otherTotal: data.priceUpdate.otherTotal,
          serviceTotal: data.priceUpdate.serviceTotal,
          details: data.details,
        });
      });
  }

  async function removeMenuItem(itemID, menuloc) {
    let linkName;
    if (menuloc == "OFI") {
      linkName = "addotherfood";
    } else {
      linkName = "menuitem";
    }
    await fetch(`/api/detail/${linkName}/`, {
      method: "delete",
      body: new URLSearchParams({
        itemId: itemID,
        id: eventData.idBanquetHeader,
        gratPercent: eventData.percentGrat,
        userId: userData.userId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setEventData({
          ...eventData,
          serviceTotal: data.priceUpdate.serviceTotal,
          fbTotal: data.priceUpdate.fbTotal,
          barTotal: data.priceUpdate.barTotal,
          details: data.details,
        });
        getServers();
      });
  }

  const handleDateChange = async (e) => {
    setEventData({ ...eventData, BanDate: e.target.value });
    setIsNotSaved(true);
  };

  const handleTimeChange = async (e) => {
    switch (e.target.name) {
      case "arrivalTime":
        setEventData({
          ...eventData,
          BanArrivalTime: e.target.value,
        });
        break;
      case "appetizerTime":
        setEventData({
          ...eventData,
          AppTime: e.target.value,
        });
        break;
      case "mealTime":
        setEventData({
          ...eventData,
          BanMealTime: e.target.value,
        });
        break;
      case "dessertTime":
        setEventData({
          ...eventData,
          DessertTime: e.target.value,
        });
        break;
      case "departureTime":
        setEventData({
          ...eventData,
          DepartureTime: e.target.value,
        });
        break;
    }
    setIsNotSaved(true);
  };

  const handleRoomChange = (e) => {
    setEventData({ ...eventData, RoomID: e.target.value });
    setIsNotSaved(true);
  };

  const handleServiceTypeChange = (e) => {
    setEventData({ ...eventData, ServiceTypeID: e.target.value });
    setIsNotSaved(true);
  };

  const handleConfirm = async () => {
    const newStatus = eventData.StatusID == 1 ? 2 : 1;
    firstUpdate.current = false;
    await setEventData({ ...eventData, StatusID: newStatus, currentStatus: newStatus == 1 ? "Tentative" : "Confirmed" });
    // setTimeout(() => {
    //   updateEvent();
    // }, 2000);
  };

  async function updateEvent() {
    //setIsLoading(true);

    const updateData = { ...eventData, userId: userData.userId };
    await fetch(`/api/event/`, {
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updateData),
    })
      .then((res) => res.json())
      .then((data) => {
        flashAlert("Event Saved");
        setIsNotSaved(false);
        //setIsLoading(false);
      });
    getEvent(updateData.idBanquetHeader);
  }

  function activateInput(e) {
    let theInput = e.target;

    if (theInput.hasAttribute("readonly")) {
      theInput.removeAttribute("readonly");
      theInput.classList.add("editMode");
      theInput.select();
      setTempInputValue(theInput.value);
      setIsEditMode(true);
    }
  }
  function deactivateInput(e) {
    if (!e.hasAttribute("readonly")) {
      e.setAttribute("readonly", "readonly");
      e.classList.remove("editMode");
      e.value = tempInputValue;
      setIsEditMode(false);
    }
  }

  async function updateGratuity(banId) {
    await setEventData({ ...eventData, addlGrat: Number(document.getElementById("gratInput").value).toFixed(2) });
    document.getElementById("gratInput").value = Number(eventData.addlGrat).toFixed(2);
    document.getElementById("gratInput").setAttribute("readonly", "readonly");
    document.getElementById("gratInput").classList.remove("editMode");
    await updateEvent();
    setIsEditMode(false);
    getServers();
  }
  async function updateRoomCharge(banId) {
    // await setEventData({ ...eventData, RoomCharge: Number(document.getElementById("roomChargeInput").value).toFixed(2) });
    document.getElementById("roomChargeInput").value = Number(eventData.RoomCharge).toFixed(2);
    document.getElementById("roomChargeInput").setAttribute("readonly", "readonly");
    document.getElementById("roomChargeInput").classList.remove("editMode");
    await updateEvent();
    setIsEditMode(false);
  }
  async function updateDeposit(banId) {
    await setEventData({ ...eventData, Deposit: Number(document.getElementById("depositInput").value).toFixed(2) });
    document.getElementById("depositInput").value = Number(eventData.Deposit).toFixed(2);
    document.getElementById("depositInput").setAttribute("readonly", "readonly");
    document.getElementById("depositInput").classList.remove("editMode");
    await updateEvent();
    setIsEditMode(false);
  }

  async function switchCustomer(newCustomer) {
    await setEventData({
      ...eventData,
      FirstName: newCustomer.FirstName,
      LastName: newCustomer.LastName,
      Phone: newCustomer.Phone,
      Email: newCustomer.Email,
      CustID: newCustomer.idCustomers,
      CompanyName: newCustomer.CompanyName,
    });

    setIsNotSaved(true);
    //updateEvent();
  }

  const firstUpdate = useRef(true);

  useEffect(() => {
    if (!firstUpdate.current) {
      const typingDelay = setTimeout(() => {
        updateEvent();
      }, 3000);

      return () => clearTimeout(typingDelay);
    }
  }, [eventData.foodNotes, eventData.setupNotes, eventData.bevNotes, eventData.EventNotes, eventData.StatusID]);

  const firstUpdateData = useRef(true);

  const banquetTotal =
    Number(eventData.fbTotal) +
    Number(eventData.barTotal) +
    Number(eventData.serviceTotal) +
    Number(eventData.otherTotal) +
    Number(eventData.RoomCharge) +
    Number(eventData.addlGrat);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <main className={styles.main}>
          <Sidebar>{eventData ? <EventMenu eventData={eventData} serverData={serverData} /> : ""}</Sidebar>
          <section className={styles.event} id="theSection">
            <div className={styles.eventHeader}>
              <div className={`${styles.eventTitle}`}>
                <h2>
                  Event Name:
                  <input
                    type="text"
                    value={eventData.BanquetName}
                    onChange={(e) => {
                      setEventData({ ...eventData, BanquetName: e.target.value });
                      setIsNotSaved(true);
                    }}
                  />
                </h2>
              </div>
              <div className={styles.statusFrame}>
                <h2>Status: {eventData.currentStatus}</h2>
                <ToggleSwitch active={eventData.StatusID == 2 ? true : false} onclick={handleConfirm} />
              </div>
            </div>

            <div className={styles.eventHeader}>
              <div>
                <h4 className={styles.headerTitle}>Event Details</h4>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Event Date:</p>
                  <p className={styles.right}>
                    <input type="date" value={String(eventData.BanDate).substring(0, 10)} onChange={handleDateChange} />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Arrival Time:</p>
                  <p className={styles.right}>
                    {/* <input type="time" /> */}
                    <TimePicker theName="arrival" theTime={eventData.BanArrivalTime} onTimeChange={handleTimeChange} />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Appetizer Time:</p>
                  <p className={styles.right}>
                    <TimePicker theName="appetizer" theTime={eventData.AppTime} onTimeChange={handleTimeChange} />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Entree/Meal Time:</p>
                  <p className={styles.right}>
                    <TimePicker theName="meal" theTime={eventData.BanMealTime} onTimeChange={handleTimeChange} />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Dessert Time:</p>
                  <p className={styles.right}>
                    <TimePicker theName="dessert" theTime={eventData.DessertTime} onTimeChange={handleTimeChange} />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Expected Departure:</p>
                  <p className={styles.right}>
                    <TimePicker theName="departure" theTime={eventData.DepartureTime} onTimeChange={handleTimeChange} />
                  </p>
                </div>
                <div className={`${styles.gridRow} ${styles.mt}`}>
                  <p className={styles.left}>Guest Count:</p>
                  <p className={styles.right}>
                    <input
                      type="number"
                      name=""
                      id=""
                      value={eventData.BanAttendance}
                      onChange={(e) => {
                        setEventData({
                          ...eventData,
                          BanAttendance: e.target.value,
                        });
                        setIsNotSaved(true);
                      }}
                    />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Banquet Area:</p>
                  <p className={styles.right}>
                    <BanquetRoomPicker location_id={eventData.LocationID} selectedRoom={eventData.RoomID} onRoomChange={handleRoomChange} />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Service Type:</p>
                  <p className={styles.right}>
                    <ServiceType selectedService={eventData.ServiceTypeID} onServiceChange={handleServiceTypeChange} />
                  </p>
                </div>
                <div className={`${styles.gridRow} ${styles.pt}`}>
                  <p>
                    <Button type="primary" onClick={updateEvent} disabled={!isNotSaved}>
                      Save
                    </Button>
                  </p>
                </div>
              </div>
              <div>
                <h4 className={styles.headerTitle}>Contact Details</h4>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Contact name:</p>
                  <p className={styles.right}>
                    {
                      <NavLink to={`/customers/${eventData.CustID}`} state={{ from: `/event/${eventData.idBanquetHeader}` }}>
                        {eventData.FirstName + " " + eventData.LastName}
                      </NavLink>
                    }
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Company:</p>
                  <p className={styles.right}>{eventData.CompanyName}</p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Telephone:</p>
                  <p className={styles.right}>{eventData.Phone}</p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>E-Mail:</p>
                  <p className={styles.right}>{eventData.Email}</p>
                </div>
                <div>
                  <CustomerSelectModal switchCustomer={switchCustomer} />
                </div>
              </div>
              <div>
                <h4 className={styles.headerTitle}>Event Totals</h4>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Sales Total:</p>
                  <p className={styles.right}>
                    <input type="text" value={Number(eventData.fbTotal + eventData.barTotal).toFixed(2)} readOnly />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Bar Total:</p>
                  <p className={styles.right}>
                    <input type="text" value={Number(eventData.barTotal).toFixed(2)} readOnly />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Service Charge:</p>
                  <p className={styles.right}>
                    <input type="text" value={Number(eventData.serviceTotal).toFixed(2)} readOnly />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Addl. Grat*:</p>
                  <p className={styles.right}>
                    <input
                      id="gratInput"
                      type="Number"
                      step="0.01"
                      defaultValue={Number(eventData.addlGrat).toFixed(2)}
                      // value={Number(eventData.addlGrat) > 0 ? eventData.addlGrat : Number(0).toFixed(2)}
                      onDoubleClick={activateInput}
                      onChange={(e) => {
                        setEventData({ ...eventData, addlGrat: Number(e.target.value) });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          updateGratuity(eventData.idBanquetHeader);
                        }
                      }}
                      readOnly
                    />
                    <i className={`fa-solid fa-floppy-disk ${styles.saveIcon}`} onClick={() => updateGratuity(eventData.idBanquetHeader)}></i>
                    <i
                      className={`fa-solid fa-xmark ${styles.closeIcon}`}
                      onClick={() => {
                        setEventData({ ...eventData, addlGrat: tempInputValue });
                        deactivateInput(document.getElementById("gratInput"));
                      }}
                    ></i>
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Other Charges:</p>
                  <p className={styles.right}>
                    <input type="text" value={Number(eventData.otherTotal).toFixed(2)} readOnly />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Room Charge*:</p>
                  <p className={styles.right}>
                    <input
                      type="text"
                      id="roomChargeInput"
                      defaultValue={Number(eventData.RoomCharge).toFixed(2)}
                      // value={Number(eventData.addlGrat) > 0 ? eventData.addlGrat : Number(0).toFixed(2)}
                      onDoubleClick={(e) => activateInput(e)}
                      onChange={(e) => {
                        setEventData({ ...eventData, RoomCharge: Number(e.target.value) });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          updateRoomCharge(eventData.idBanquetHeader);
                        }
                      }}
                      readOnly
                    />
                    <i className={`fa-solid fa-floppy-disk ${styles.saveIcon}`} onClick={() => updateRoomCharge(eventData.idBanquetHeader)}></i>
                    <i
                      className={`fa-solid fa-xmark ${styles.closeIcon}`}
                      onClick={() => {
                        setEventData({ ...eventData, RoomCharge: tempInputValue });
                        deactivateInput(document.getElementById("roomChargeInput"));
                      }}
                    ></i>
                  </p>
                </div>

                <div className={styles.gridRow}>
                  <p className={styles.left}>Event Total:</p>
                  <p className={styles.right}>
                    <input type="text" value={Number(banquetTotal).toFixed(2)} readOnly />
                  </p>
                </div>
                <div className={styles.gridRow}>
                  <hr className={styles.left} />
                  <hr className={styles.right} />
                </div>
                <div className={styles.gridRow}>
                  <p className={styles.left}>Deposit*:</p>
                  <p className={styles.right}>
                    <input
                      className={`${Number(eventData.Deposit > 0) ? `${styles.deposit}` : ""} `}
                      type="text"
                      id="depositInput"
                      defaultValue={Number(eventData.Deposit).toFixed(2)}
                      // value={Number(eventData.addlGrat) > 0 ? eventData.addlGrat : Number(0).toFixed(2)}
                      onDoubleClick={(e) => activateInput(e)}
                      onChange={(e) => {
                        setEventData({ ...eventData, Deposit: Number(e.target.value) });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          updateDeposit(eventData.idBanquetHeader);
                        }
                      }}
                      readOnly
                    />
                    <i className={`fa-solid fa-floppy-disk ${styles.saveIcon}`} onClick={() => updateDeposit(eventData.idBanquetHeader)}></i>
                    <i
                      className={`fa-solid fa-xmark ${styles.closeIcon}`}
                      onClick={() => {
                        setEventData({ ...eventData, Deposit: tempInputValue });
                        deactivateInput(document.getElementById("depositInput"));
                      }}
                    ></i>
                  </p>
                </div>
                <div className={styles.asterikDiv}>
                  <small>* Double click box to change values</small>
                </div>
              </div>
            </div>

            <div className={styles.notesArea}>
              <div className={styles.eventNotes}>
                <h4 className={styles.headerTitle}>Event Notes:</h4>
                <div>
                  <textarea
                    name=""
                    id=""
                    className={styles.textArea}
                    value={eventData.EventNotes != null ? String(eventData.EventNotes).split("<br />").join("\n") : ""}
                    onChange={(e) => {
                      setEventData({
                        ...eventData,
                        EventNotes: e.target.value,
                      });
                      setIsNotSaved(true);
                    }}
                  ></textarea>
                </div>
              </div>
              <div className={styles.setupNotes}>
                <h4 className={styles.headerTitle}>Room Set-up / AV:</h4>
                <div>
                  <textarea
                    name=""
                    id=""
                    className={styles.textArea}
                    value={eventData.setupNotes != null ? String(eventData.setupNotes).split("<br />").join("\n") : ""}
                    onChange={(e) => {
                      setEventData({
                        ...eventData,
                        setupNotes: e.target.value,
                      });
                      setIsNotSaved(true);
                    }}
                  ></textarea>
                </div>
              </div>
              <div className={styles.commArea}>
                <h4 className={styles.headerTitle}>
                  Communication: <AddCommunicationModal eventData={eventData} getComms={getComms} />
                </h4>
                <div className={styles.commAreaList}>
                  {communication.map((comm) => {
                    return (
                      <p className={styles.singleComm}>
                        <span>{`${comm.FirstName} - ${String(comm.EventDate).substring(0, 10)}`}</span>
                        <br />
                        {comm.EventDesc}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className={styles.sectionLeft}>
              <div className={styles.eventMenu}>
                <h4 className={styles.headerTitle}>Menu Detail:</h4>
                <div>
                  <table className={styles.menuTable}>
                    <thead>
                      <tr>
                        <th>Description</th>
                        <th>Menu Item Notes</th>
                        <th>Category</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Addons</th>
                        <th>Subtotal</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(eventData.details) &&
                        eventData.details.map((bd, index) => {
                          if (bd.Category != "ONF")
                            return (
                              <tr className={bd.isParent ? styles.isParentRow : ""}>
                                <td>
                                  {bd.isParent ? (
                                    bd.item
                                  ) : (
                                    <span className={styles.childmenuitem}>
                                      {bd.item} {bd.isPricePer ? "" : ""}
                                    </span>
                                  )}
                                </td>
                                <td className={styles.menuItemNotes}>
                                  {/* {bd.menuItemNotes != null || bd.menuItemNotes != "null" || bd.menuItemNotes != "" ? (
                                    <pre>{String(bd.menuItemNotes)}</pre>
                                  ) : (
                                    //.split("\n")
                                    //.join("<br>")
                                    ""
                                  )} */}
                                  {bd.menuItemNotes && <pre>{bd.menuItemNotes}</pre>}
                                </td>
                                <td>{categories.filter((el) => el.id == bd.Category)[0].descriptions}</td>
                                <td>{bd.isParent ? bd.qty : ""}</td>
                                <td>{bd.isParent ? (bd.isPricePer ? `${Number(bd.Price).toFixed(2)}/pp` : Number(bd.Price).toFixed(2)) : ""}</td>
                                <td>
                                  {bd.isParent ? (bd.isPricePer ? `${Number(bd.addOnPrice).toFixed(2)}/pp` : Number(bd.addOnPrice).toFixed(2)) : ""}
                                </td>
                                <td>{bd.isParent ? Number(bd.pricePerTotal).toFixed(2) : ""}</td>
                                {bd.isParent ? (
                                  <td>
                                    <AddMenuNotesModal bd={bd} eventData={eventData} setEventData={setEventData} getServers={getServers} />
                                    <Button
                                      type="primary"
                                      onClick={(e) => {
                                        popup(
                                          "Remove Menu Item",
                                          "Are you sure you want to remove this menu item?",
                                          () => removeMenuItem(bd.itemId, bd.menuLocation),
                                          e
                                        );
                                      }}
                                    >
                                      Remove
                                    </Button>
                                  </td>
                                ) : (
                                  ""
                                )}
                              </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={5}></td>
                      </tr>
                    </tfoot>
                  </table>
                  <div className={styles.buttonGroup}>
                    <AddMenuItemModal
                      eventData={eventData}
                      bID={eventData.idBanquetHeader}
                      setEventData={setEventData}
                      getServers={getServers}
                      categoryNames={categories}
                      makeInvalid={makeInvalid}
                    />
                    <AddOtherFoodModal
                      eventData={eventData}
                      bID={eventData.idBanquetHeader}
                      setEventData={setEventData}
                      getServers={getServers}
                      makeInvalid={makeInvalid}
                      categories={categories}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.eventMenu}>
                <h4 className={styles.headerTitle}>Other Detail/Charges:</h4>
                <div>
                  <table className={`${styles.menuTable} ${styles.otherTable}`}>
                    <thead>
                      <tr>
                        <th>Description</th>
                        {/* <th>Quantity</th> */}
                        <th>Price</th>
                        <th>Subtotal</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(eventData.details) &&
                        eventData.details.map((bd) => {
                          if (bd.Category == "ONF")
                            return (
                              <tr>
                                <td>{bd.item}</td>
                                {/* <td >{bd.qty}</td> */}
                                <td>{Number(bd.Price).toFixed(2)}</td>
                                <td>{Number(bd.qty * bd.Price).toFixed(2)}</td>
                                <td>
                                  <Button
                                    type="primary"
                                    onClick={(e) => {
                                      popup(
                                        "Remove Other Item",
                                        "Are you sure you want to remove this other event item?",
                                        () => removeOtherItem(bd.itemId),
                                        e
                                      );
                                    }}
                                  >
                                    Remove
                                  </Button>
                                </td>
                              </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={5}></td>
                      </tr>
                    </tfoot>
                  </table>
                  <AddOtherItemModal setEventData={setEventData} eventData={eventData} bID={eventData.idBanquetHeader} makeInvalid={makeInvalid} />
                </div>
              </div>

              <div className={styles.eventEmployees}>
                <h4 className={styles.headerTitle}>Employee Detail:</h4>
                <div>
                  <table className={styles.employeeTable}>
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Role</th>
                        <th>Grat</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ServerList servData={serverData} removeEmployee={removeEmployee} />
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={4}></td>
                      </tr>
                    </tfoot>
                  </table>
                  <AddEmployeeModal eventData={eventData} getServers={getServers} servData={serverData} makeInvalid={makeInvalid} />
                </div>
              </div>
            </div>
            <div className={styles.sectionRight}></div>
            {/* </div> */}

            <div className={styles.eventFooter}>
              <p>
                Created on: {eventData.createdDate ? new Date(eventData.createdDate.replace("Z", "")).toDateString() : ""} by {eventData.createdBy}
              </p>
              <p>
                Last Updated on: {eventData.lastUpdate ? new Date(eventData.lastUpdate.replace("Z", "")).toDateString() : ""} by{" "}
                {eventData.UserLastUpdate}
              </p>
            </div>
          </section>
        </main>
      )}
    </>
  );
}

export default Event;
